import { render, staticRenderFns } from "./content_view.vue?vue&type=template&id=c6513706&"
import script from "./content_view.vue?vue&type=script&lang=js&"
export * from "./content_view.vue?vue&type=script&lang=js&"
import style0 from "./content_view.vue?vue&type=style&index=0&id=c6513706&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports